import { getTourSettings, updateTourSettings } from '../../../services/admin-tours';
import { SavedSwitchSetting } from './SavedSwitchSetting';

const loadTourVisibility = async (signal: AbortSignal) =>
  (await getTourSettings(signal)).enabledForEveryone;

const saveTourVisibility = async (next: boolean, signal: AbortSignal) =>
  (await updateTourSettings(next, signal)).enabledForEveryone;

/**
 * The global switch deciding whether coaches see guided tours at all.
 *
 * Tours ship off. While the switch is off the API serves them to system admins only, which is how a
 * new or edited tour gets checked on the real pages before a coach ever meets it. On a 404 the API
 * predates the switch, so tours still show to everyone.
 */
export const TourVisibilitySetting = () => (
  <SavedSwitchSetting
    load={loadTourVisibility}
    save={saveTourVisibility}
    label="Show guided tours to everyone"
    description="When this is off, only system admins see tours, so you can check them first."
    loadingText="Loading the guided tours setting..."
    loadErrorText="Could not load the guided tours setting."
    unavailableText="The switch for showing tours to everyone is not on this server yet."
    idPrefix="tour-visibility"
  />
);
